import { render, staticRenderFns } from "./HorseActes.vue?vue&type=template&id=1cf444a8&"
import script from "./HorseActes.vue?vue&type=script&lang=js&"
export * from "./HorseActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports